export default () => ({
    nombre: "",
    permisos: "",
    company: "",
    corporation: "",
    status: true,
  });